import { render, staticRenderFns } from "./bag.vue?vue&type=template&id=ae9305aa"
import script from "./bag.vue?vue&type=script&lang=js"
export * from "./bag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports